import React, {useEffect, useRef, useState} from 'react'
import AppStore from 'stores/app.store';
import system from 'helpers/system';
import {useSearchParams} from 'react-router-dom';
import constants from 'helpers/constants';
import utils from 'helpers/utils';
import axios from 'axios';
import {useSnackbar} from 'components/organisms/Providers/SnackbarProvider/SnackbarProvider';
import Icon from 'components/atoms/Icons/Icon/Icon';
import Refresh from '@mui/icons-material/Refresh';
import {usePageVisibility} from 'helpers/hooks/utils';

export const AppContext = React.createContext(null)

export function useAppStore () {
  return React.useContext(AppContext);
}

const app = new AppStore(system.appName(), {
  defaultParent: {
    key: 'clientId',
    listKey: 'clientIds'
  }
});

const AppProvider = ({children}) => {
  const checkVersionRef = useRef({});

  const [version, setVersion] = useState(null);
  const [searchParams] = useSearchParams();

  const isPageVisible = usePageVisibility();
  const verbosity = searchParams.get('verbosity');

  const snackbar = useSnackbar();

  useEffect(() => {
    system.appVerbosity(verbosity);
  }, [verbosity]);

  useEffect(() => {
    const checkVersion = () => {
      if (isPageVisible) {
        if (!checkVersionRef.current.checking) {
          checkVersionRef.current.checking = true;
          axios.get(`${window.location.origin}/index.html`, {
            headers: {
              'Cache-Control': 'no-cache, no-store, must-revalidate',
              'Pragma': 'no-cache',
              'Expires': '0'
            }
          })
            .then((res) => {
              const match = res.data.match(/<meta[^>]*name="version"[^>]*content="([^>]+)"[^>]*\/>/i);
              if (match?.length > 1 && match[1]?.length > 0) {
                setVersion(match[1]);
              }
            })
            .catch(() => {
              /* SQUASH */
            })
            .finally(() => {
              checkVersionRef.current.checking = false;
            });
        }
      }
    }

    // check on becoming visible
    if (checkVersionRef.current.wasPageVisible === false && isPageVisible) {
      checkVersion();
    }
    checkVersionRef.current.wasPageVisible = isPageVisible;

    return utils.observeInterval(() => {
      checkVersion();
    }, constants.delay.version);
  }, [isPageVisible]);

  useEffect(() => {
    const handleRefresh = () => {
      window.location.reload();
    }

    if (utils.isDefined(version) && version !== system.appVersion()) {
      snackbar.show(`A new version of ${constants.basics.shortName} is now available. Save your work and click refresh`, 'Refresh',
        {color: 'primary', autoHideDuration: null, ButtonProps: { startIcon: <Icon icon={Refresh}/> }}, handleRefresh, null, false);
    }
  }, [version, snackbar]);

  return <AppContext.Provider value={app}>
    {children}
  </AppContext.Provider>
};

AppProvider.propTypes = {
}

export default AppProvider;
